import { useState, useEffect } from "react"
import { useRouter } from "../../../../hooks/router"

import Pay from "./Pay"
import Service from "./service"

export default function Payment({ tariffs }) {

    const router = useRouter()

    const [type, setType] = useState('')
    const [selectedTariff, setSelectedTariff] = useState(null)
    const [activeTarffsIndex, setActiveTarffsIndex] = useState([])

    useEffect(() => {

        if (router.query.a == 'payment' && router.query.content_id) {

            const newArray = []

            for (let i = 0; i < tariffs.length; i++) {

                if (router.query.content_type == 'vod') {
                    // setActiveTarffsIndex(tariffs[i])
                    let active_service = tariffs[i].service.find(e => e.serviceId == 5)

                    if (active_service && active_service.value.indexOf(router.query.content_id) > -1) {

                        newArray.push(tariffs[i].id)

                    }

                } else {

                    let active_service = tariffs[i].service.find(e => e.serviceId == 1)

                    if (active_service && active_service.value.indexOf(router.query.content_id) > -1) {

                        newArray.push(tariffs[i].id)

                    }

                }

            }

            console.log(newArray, 'newArray')

            setActiveTarffsIndex([...newArray])

        }

    }, [router.query, tariffs.length]);

    const set_class = (e, i) => {

        if (i != 0 && (i == 1 || i % 4 == 0)) return 'main '

        return 'bg_color'

    }

    const select_plan = (e) => {
        setSelectedTariff(e)
        setType('pay')
    }

    return (
        type == 'pay' ? <Pay tariff={selectedTariff} setType={setType} />
            : <div className="main_payment_settings">
                {(tariffs.map((e, i) => {

                    return (
                        <div key={e.id} className={"card_color main_card_tariff " + (activeTarffsIndex.indexOf(tariffs[i].id) > -1 ? "main" : 'bg_color')}>

                            <div className={"circle_in_tariff bg_color "}></div>

                            <h2 className="name_tariff">{e.name}</h2>

                            <h3 className="price_tariff">
                                <span className="main_price_traif">
                                    <span className="currensy">$</span>
                                    {e.price.toFixed(2)}
                                </span>
                            </h3>

                            <h4 className="scheduling_time">{e.scheduling_time} {e.scheduling_type}</h4>

                            <div className="main_tariff_servie">
                                {
                                    e.service.map(el => {

                                        return <Service key={el.id} service={el} />

                                    })
                                }
                            </div>

                            <button onClick={() => select_plan(e)}> SELECT PLAN</button>

                        </div>
                    )
                }))}
            </div >
    )
}